import { render, staticRenderFns } from "./addNewEmp.vue?vue&type=template&id=d59b88f2&scoped=true&"
import script from "./addNewEmp.vue?vue&type=script&lang=js&"
export * from "./addNewEmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59b88f2",
  null
  
)

export default component.exports